import { useSortable } from '@dnd-kit/sortable';
import CodeIcon from '@mui/icons-material/Code';
import { Box, Grid } from '@mui/material';
import cx from 'classnames';
import React from 'react';
import { FBFieldTopBarProps } from '..';
import { ReactComponent as DragHandleIcon } from '../../../assets/images/drag_handle.svg';
import { ReactComponent as EditIcon } from '../../../assets/images/edit.svg';
import { ReactComponent as RemoveIcon } from '../../../assets/images/remove.svg';
import useStyles from './FBFieldTopBar.styles';
import { withFBFieldTopBar } from './FBFieldTopBar.wrap';

const FBFieldTopBar: React.FunctionComponent<FBFieldTopBarProps> = ({
  editSchemaItem,
  removeSchemaItem,
  toggleItemMarkdown,
  inputProps = {},
}) => {
  const classes = useStyles();
  const { disabled, name = '' } = inputProps;
  const { listeners } = useSortable({ id: name });

  const deleteDisabled = inputProps.deleteDisabled || disabled;
  const editDisabled = inputProps.editInFormDisabled || disabled;
  const moveDisabled = disabled && !inputProps.moveable;

  return (
    <Box className={classes.root}>
      <Grid container className={classes.tools}>
        <DragHandleIcon
          data-cy="drag-schema-item"
          className={cx(classes.dragIcon, 'drag-handle', { [classes.disabledAction]: moveDisabled })}
          {...!moveDisabled && listeners}
        />
        <CodeIcon onClick={toggleItemMarkdown} data-cy="view-schema-item-markdown" />
        <EditIcon
          data-cy="edit-schema-item"
          className={cx({ [classes.disabledAction]: editDisabled })}
          onClick={editDisabled ? undefined : editSchemaItem}
        />
        <RemoveIcon
          data-cy="remove-schema-item"
          className={cx(
            deleteDisabled ? 'schema-delete-disabled' : 'schema-delete-enabled',
            { [classes.disabledAction]: deleteDisabled },
          )}
          {...!deleteDisabled && { onClick: removeSchemaItem }}
        />
      </Grid>
    </Box>
  );
};

export default withFBFieldTopBar(FBFieldTopBar);
